var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeili(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1908_167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 29L9.238 5.493A8.684 8.684 0 0117.327 0h5.57l-9.24 23.507A8.683 8.683 0 015.57 29H0z",
    fill: "url(#paint0_linear_1908_167)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.552 29L22.79 5.493A8.684 8.684 0 0130.878 0h5.57L27.21 23.507A8.684 8.684 0 0119.122 29h-5.57z",
    fill: "url(#paint1_linear_1908_167)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.105 29l9.238-23.507A8.683 8.683 0 0144.43 0H50l-9.238 23.507A8.683 8.683 0 0132.673 29h-5.568z",
    fill: "url(#paint2_linear_1908_167)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1908_167",
    x1: 47.672,
    y1: -6.315,
    x2: -2.197,
    y2: 22.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4E62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1908_167",
    x1: 51.007,
    y1: -0.444,
    x2: 1.138,
    y2: 27.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4E62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1908_167",
    x1: 54.341,
    y1: 5.428,
    x2: 4.473,
    y2: 33.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4E62"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1908_167"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h50v29H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeili);
export default __webpack_public_path__ + "static/media/meili.5bb8f4490e6a8dbd1b4dc1b6039ed581.svg";
export { ForwardRef as ReactComponent };